module.exports = __webpack_public_path__ + "static/media/3DPPA17.8e135298.jpg";